import { Injectable } from '@angular/core';
import { RidangoReduxAction } from '@ridango/core';


@Injectable()
export class AreasActions {
    static SET_ALL_AREAS = '[Areas]: Set All Areas';
    static SET_SELETED_AREA = '[Areas]: Set Selected Area';
    static CLEAR_AREAS = '[Areas]: Clear Areas';
    setAllAreas(payload): RidangoReduxAction {
        return {
            type: AreasActions.SET_ALL_AREAS,
            payload: payload
        };
    }
    setSelectedArea(payload): RidangoReduxAction {
        return {
            type: AreasActions.SET_SELETED_AREA,
            payload: payload
        };
    }
    clearAreas(): RidangoReduxAction {
        return {
            type: AreasActions.CLEAR_AREAS
        };
    }
}


